module.exports = __webpack_public_path__ + "static/media/arrowDownBlack.e9df593e.svg";